import { useState, useEffect } from 'react';
import api from 'services/api';

export const useAllPermissions = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPermissions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/permissions');
      const data = response.data;
      
      if (data.success && data.data) {
        // Se a resposta tem estrutura { success: true, data: [...] }
        if (Array.isArray(data.data)) {
          setPermissions(data.data);
        } else {
          // Se data é um objeto com categorias, extrair todas as permissões
          const permissionsArray = Object.values(data.data).flat();
          setPermissions(permissionsArray);
        }
      } else if (Array.isArray(data)) {
        // Se a resposta é diretamente um array
        setPermissions(data);
      } else {
        throw new Error('Formato de resposta inválido');
      }
    } catch (err) {
      console.error('Erro ao carregar permissões:', err);
      setError(err.message || 'Erro ao carregar permissões');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPermissions();
  }, []);

  return {
    permissions,
    loading,
    error,
    loadPermissions
  };
};

